import React from 'react'
import BaseIcon from 'react-icon-base'

const USA = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <path id="c" d="M0 0h9v7H0z" />
      <filter id="d" width="111.1%" height="114.3%" x="-5.6%" y="-7.1%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius="1" result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
      </filter>
      <rect id="e" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <g mask="url(#b)">
        <use fill="#435DB0" xlinkHref="#c" />
        <use fill="#000" filter="url(#d)" xlinkHref="#c" />
      </g>
      <path
        fill="#A7B6E6"
        d="M1 1v1h1V1H1zm2 0v1h1V1H3zm2 0v1h1V1H5zm2 0v1h1V1H7zM6 2v1h1V2H6zM4 2v1h1V2H4zM2 2v1h1V2H2zM1 3v1h1V3H1zm2 0v1h1V3H3zm2 0v1h1V3H5zm2 0v1h1V3H7zM1 5v1h1V5H1zm2 0v1h1V5H3zm2 0v1h1V5H5zm2 0v1h1V5H7zM6 4v1h1V4H6zM4 4v1h1V4H4zM2 4v1h1V4H2z"
        mask="url(#b)"
      />
      <path
        fill="#ED4C49"
        d="M9 0v1h12V0H9zm0 2v1h12V2H9zm0 2v1h12V4H9zm0 2v1h12V6H9zM0 8v1h21V8H0zm0 2v1h21v-1H0zm0 2v1h21v-1H0zm0 2v1h21v-1H0z"
        mask="url(#b)"
      />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#e" />
    </g>
  </BaseIcon>
)

export default USA
